"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadPdf = exports.pdfExport = void 0;
var file_1 = require("@devexpress/utils/lib/utils/file");
var exporter_1 = require("../exporter");
function pdfExport(docProcessor, callback, options) {
    new exporter_1.PdfExporter(docProcessor).export(callback, options);
}
exports.pdfExport = pdfExport;
function downloadPdf(docProcessor, fileName, options) {
    pdfExport(docProcessor, function (blob, _stream) {
        file_1.FileUtils.startDownloadFileLocal(blob, fileName + '.pdf');
    }, options);
}
exports.downloadPdf = downloadPdf;
